import { useState } from "react";
import { useTranslations } from "next-intl";
import { useRouter } from "@lib/i18n/navigation-pages-router";
import { useCurrentUser } from "@hooks/use-current-user";
import Button from "@components/core/Button";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import Image from "@components/core/Image";
import closetStates from "@utils/constants/closetStates";
import UnsubscribeModalAskCustomerService from "../SubscriptionCancelation/UnsubscribeModal/UnsubscribeModalAskCustomerService";
import UnsubscribeModalTryAnotherCloset from "../SubscriptionCancelation/UnsubscribeModal/UnsubscribeModalTryAnotherCloset";

function SubscriptionPauseAskNew() {
  const t = useTranslations("accounts");

  const router = useRouter();
  const user = useCurrentUser();
  const currentCloset = useCustomizableCloset();

  const [modalOpened, setModalOpened] = useState("");

  function askForPause() {
    if (!user.received_at_least_one_closet) {
      setModalOpened("ask_customer_service");
      return;
    }

    if (user.closets_count === 1 && currentCloset.state === closetStates.received) {
      setModalOpened("try_another_closet");
      return;
    }

    router.push("/profile/manage-subscription/pause");
  }

  function close() {
    setModalOpened("");
  }

  return (
    <div
      data-testid="manage-subscription-pause-new-section"
      className="manage-subscription-card"
    >
      <div className="manage-subscription-card-content">
        <div className="p-3 d-flex flex-column align-items-center">
          <h5 className="text-center mb-0">{t("manage_subscription.pause.new.title")}</h5>

          <div
            className="my-5"
            style={{ width: "128px" }}
          >
            <Image
              src="handbagSleepingRetro"
              alt={t("manage_subscription.pause.alt")}
              className="w-100"
            />
          </div>

          <p className="text-center">{t("manage_subscription.pause.new.description")}</p>
        </div>

        <div className="p-2 d-flex justify-content-center border-top">
          <Button
            variant="ghost-primary"
            onClick={askForPause}
          >
            {t("manage_subscription.pause.new.ask_for_pause")}
          </Button>
        </div>
      </div>

      <UnsubscribeModalAskCustomerService
        opened={modalOpened === "ask_customer_service"}
        close={close}
      />
      <UnsubscribeModalTryAnotherCloset
        opened={modalOpened === "try_another_closet"}
        close={close}
      />
    </div>
  );
}

export default SubscriptionPauseAskNew;
